/* eslint-disable @stylistic/multiline-ternary */
/* eslint-disable @typescript-eslint/typedef */
import { ActionReference, DefaultGameState, GameObjectReference, GameState } from "@shared/types";
import { css, html, htmlArray } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { GameRouteService } from "../services/GameRouteService";
import { Page } from "../enums/Page";

/** CSS affecting the {@link CanvasComponent} */
const styles: string = css`
    :host {
        font-family: "Eagle Lake", serif;
        font-weight: 400;
        font-style: normal;
        width: 100%;
        height: 100%;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto calc(35vh + 10px) minmax(calc(35vh + 10px), 1fr) auto;
        grid-column-gap: 0px;
        grid-row-gap: 0px;
    }

    .title {
        text-align: center;
        margin-top: 5px;
        overflow: auto;
        font-size: 13px;
    }

    .header {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin-top: 10px;
        width: 100%
    }

    .header img {
        width: 87%;
        height: 94.5vh;
        image-rendering: pixelated;
        z-index: -1;
    }

    .header img:nth-child(n + 2) {
        position: absolute;
    }

    .content {
        flex-grow: 1;
        overflow: auto;
        padding: 0 10px;
        outline-style: solid;
        outline-width: 1px;
        outline-color: grey;
        padding: 10px;
        width: 85%;
        height: 150px;
        margin: auto;
        margin-bottom: 20px;
        background-color: rgba(79, 68, 60, 0.8);
        border-radius: 15px;
        font-size: 16.5px;
        box-shadow: inset 0px 0px 20px 3px rgba(0, 0, 0, 0.8),
                    0px 0px 10px 2px rgba(0, 0, 0, 0.9);
    }

    .content p {
        margin: 0 0 10px 0;
        color: #FDF6E4;
    }   

    .content p:last-of-type {
        margin: 0;
    }

    .footer {
        margin: auto;
        height: 150px;
        z-index: 1;
        width: 80%;
    }

    .footer .buttons {
        margin-top: 2px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        max-height: 87px;
        overflow: auto;
        padding: 10px 10px 5px 5px;
        z-index: 1;
        align-items: flex-start;
    
        background: rgba(20, 20, 20, 0.4);
        backdrop-filter: blur(2px);
        border-radius: 8px;
    }

    .footer .button {
        background-color: #A04343;
        outline-style: solid;
        outline-color: grey;
        outline-width: 1px;
        padding: 10px 30px;
        margin: 5px;
        border-radius: 10px;
        box-shadow: inset 0px 0px 20px 3px rgba(0, 0, 0, 0.8),
                    0px 0px 10px 2px rgba(0, 0, 0, 0.9);
        text-transform: uppercase;
        cursor: pointer;
        display: inline-block;
        user-select: none;
        z-index: 1;
        width: 125px;
        font-size: 16px;
        text-align: center;
        justify-content: center;
        align-items: center;
        display: flex;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
    }

    .footer .button::before {
        content: "";
        position: absolute;
        top: -10px;
        left: -10px;
        width: calc(100% + 20px);
        height: calc(100% + 20px);
        border-radius: 15px;
        background: rgba(255, 215, 0, 0.5);
        opacity: 0;
        transition: opacity 0.3s ease;
        box-shadow: 0 0 20px 5px rgba(255, 215, 0, 1), 0 0 30px 15px rgba(255, 215, 0, 0.8);
    }

    .footer .button:hover::before {
        opacity: 1;
    }


    .footer .button {
        position: relative;
        overflow: hidden;
    }

    .hidden {
        display: none;
    }

    .center {
        position: absolute;
        top: 80%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 20px;
        width: 300px;
        height: 350px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
    }

    .start-ui {
        width: 250px !important;
        height: 25px;
        margin-top: 30px !important;
        font-size: 20px !important;
    }

    .footer .button::after {
        content: "";
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.6), transparent);
        transition: left 0.6s ease-in-out;
    }

    .footer .button:hover::after {
        left: 100%;
    }

    .footer .button.active,
    .footer .button:hover {
        background-color: #332c57;
        z-index: 1;
    }

    .footer .button:hover {
        transform: scale(1.02);
        box-shadow: 0 0 10px rgba(255, 215, 0, 0.8), 0 0 25px rgba(255, 215, 0, 0.6);
        transition: transform 0.15s ease, box-shadow 0.3s ease;
    }

    .footer-logo {
        position: absolute;
        top: -320px;
        left: 46.5%; 
        transform: translateX(-50%); 
        width: 375px; 
        height: auto; 
    }

    .max-height {
        max-height: 200px !important;
        background: none !important;
        backdrop-filter: none !important;
    }
    
    .inventory-button {
        position: absolute; /* Positioneer de knop absoluut binnen de header */
        top: 10px; /* Zet de knop 10px van de bovenkant van de header */
        left: 10px; /* Zet de knop 10px van de linkerkant van de header */
        z-index: 10; /* Zorg ervoor dat de knop boven de afbeelding komt */
        padding: 0px; /* Ruimte in de knop */
        color: white; /* Tekstkleur */
        background-color: transparent; /* Verwijder de achtergrondkleur */
        border: none; /* Geen rand */
        font-size: 16px; /* Tekstgrootte */
        cursor: pointer; /* Verandert de cursor naar een pointer */
        width: auto; /* Zorg ervoor dat de knop automatisch wordt geschaald */
        height: auto; /* Zorg ervoor dat de knop automatisch wordt geschaald */
        margin-left: 130px;
        margin-top: 15px;
    }

    /* Zorg ervoor dat de afbeelding binnen de knop past */
    .inventory-button img {
        width: 100px; /* Pas dit aan naar de gewenste breedte van je afbeelding */
        height: 100px; /* Pas dit aan naar de gewenste hoogte van je afbeelding */
        object-fit: contain; /* Zorg ervoor dat de afbeelding goed binnen de knop past */
        margin: 0;
        transition: transform 0.2s ease; /* Zorg voor een soepele overgang bij hover */
    }

    /* Hover-effect voor de knop */
    .inventory-button:hover img {
        transform: scale(1.2); /* Verhoog de grootte van de afbeelding bij hover (20%) */
    }
    .testbox {
        display: flex;
    }
    .objectFlex {
        display: flex;
    }

    .info-box {
        position: absolute;
        top: 60px;
        right: 180px;
        width: 350px;
        background: rgba(0, 0, 0, 0.75);
        color: white;
        padding: 15px;
        border-radius: 5px;
    
        /* EXTREME shadow voor vloeiende overgang naar de achtergrond */
        box-shadow: 0px 0px 90px 40px rgba(0, 0, 0, 0.8);

    }

    .info-box-title {
        color: #a0cfff; /* Lichtblauw voor een fantasy-look */
        font-family: 'Cinzel', serif; /* Een fantasy-achtig lettertype */
        font-size: 26px;
        font-weight: bold;
    }

    .info-box hr {
        border: none;
        height: 1px;
        background: white;
        margin-bottom: 10px;
    }

    .info-slot {
        color: white;
        font-family: 'Oswald', sans-serif; /* Scherpe, strakke font */
        font-size: 18px;
    }
`;

/**
 * Represents the Canvas page
 */
export class CanvasComponent extends HTMLElement {
    /** Instance of the game event service */
    private readonly _gameEventService: GameEventService = new GameEventService();
    /** Instance of the game route service */
    private readonly _gameRouteService: GameRouteService = new GameRouteService();

    /** Current game state */
    private _currentGameState?: DefaultGameState;
    /** Current active action button */
    private _selectedActionButton?: ActionReference;
    /** Current active game object buttons */
    private _selectedGameObjectButtons: Set<GameObjectReference> = new Set<GameObjectReference>();

    /**
     * The "constructor" of a Web Component
     */
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        void this.refreshGameState();
    }

    /**
     * Refresh the current game state
     */
    private async refreshGameState(): Promise<void> {
        const state: GameState = await this._gameRouteService.getGameState();

        this.updateGameState(state);
    }

    /**
     * Update the canvas to the provided game state
     *
     * @param state Game state to update the canvas to
     */
    private updateGameState(state: GameState): void {
        // Handle switching pages, if requested.
        if (state.type === "switch-page") {
            this._gameEventService.switchPage(state.page as Page);

            return;
        }

        // Reset the component
        this._currentGameState = state;

        this._selectedActionButton = undefined;
        this._selectedGameObjectButtons.clear();

        // Refresh the web component
        this.render();
    }

    /**
     * Render the contents of this page
     */
    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const elements: HTMLElement[] = htmlArray`
            <style>
                ${styles}
            </style>

            ${this.renderTitle()}
            ${this.renderHeader()}
            ${this.renderContent()}
            ${this.renderFooter()}
            ${this.renderInfoBox()}
        `;

        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }

        this.shadowRoot.append(...elements);

        setTimeout(() => {
            // Puts all elements with class header into this variable
            const roomImageElements: NodeListOf<HTMLDivElement> = this.shadowRoot!.querySelectorAll(".header");

            // Loops through roomImageElements
            for (let i: number = 0; i < roomImageElements.length; i++) {
                // Checks whether an image with the name startup-wallpaper exists
                if (roomImageElements[i].querySelector("img")!.src.indexOf("startup-wallpaper") !== -1) {
                    // Selecting the content elements
                    const content: NodeListOf<HTMLElement> = this.shadowRoot!.querySelectorAll(".content");
                    const title: NodeListOf<HTMLElement> = this.shadowRoot!.querySelectorAll(".title");
                    const footer: NodeListOf<HTMLElement> = this.shadowRoot!.querySelectorAll(".footer");
                    const buttons: NodeListOf<HTMLElement> = this.shadowRoot!.querySelectorAll(".footer .button");
                    const buttonsheight: NodeListOf<HTMLElement> = this.shadowRoot!.querySelectorAll(".footer .buttons");
                    const noinfobox: NodeListOf<HTMLElement> = this.shadowRoot!.querySelectorAll(".info-box");

                    content[0].classList.add("hidden");
                    title[0].classList.add("hidden");
                    footer[0].classList.add("center");
                    buttonsheight[0].classList.add("max-height");
                    noinfobox[0].classList.add("hidden");

                    buttons.forEach(button => {
                        button.classList.add("start-ui");
                    });

                    // Maak het logo element aan
                    const logoElement: HTMLImageElement = document.createElement("img");
                    logoElement.src = "assets/img/rooms/game-logo.png";
                    logoElement.alt = "Logo";
                    logoElement.classList.add("footer-logo");

                    // Controleer of de footer daadwerkelijk bestaat en voeg het logo toe
                    if (footer.length > 0) {
                        footer[0].appendChild(logoElement);
                    }
                }
            }
        }, 0);
    }

    /**
     * Render the title element
     *
     * @returns String with raw HTML for the title element. Can be empty.
     */
    private renderTitle(): string {
        const roomName: string | undefined = this._currentGameState?.roomName;

        if (roomName) {
            return `<div class="title">${roomName}</div>`;
        }

        return "";
    }

    /**
     * Render the header element
     *
     * @returns String with raw HTML for the header element. Can be empty.
     */

    private renderHeader(): string {
        setTimeout(() => {
            const InventoryButton: HTMLButtonElement = this.shadowRoot!.getElementById("inventoryButton") as HTMLButtonElement;
            if (!InventoryButton.hasAttribute("data-listener")) {
                InventoryButton.setAttribute("data-listener", "true");
                InventoryButton.addEventListener("click", () => {
                    const inventory: HTMLElement | null = this.shadowRoot!.getElementById("game-inventory");
                    if (inventory) {
                        inventory.style.display = inventory.style.display === "inline" ? "none" : "inline";
                    }
                });
            }
        });

        const roomImages: string[] | undefined = this._currentGameState?.roomImages;

        if (roomImages && roomImages.length > 0) {
            const isStartPage = roomImages.some(img => img.includes("startup-wallpaper"));

            return `
                <div class="header">
                    <game-inventory id="game-inventory"></game-inventory>
                    ${roomImages.map(url => `<img src="/assets/img/rooms/${url}.png" />`).join("")}
    
                    ${!isStartPage ? `
                    <button id="inventoryButton" 
                        style="position: fixed; left: 27px; top: 55px; height: 100px; width: 90px; background: none; border: none;" 
                        class="inventory-button button">
                        <img src="/assets/img/rooms/backpack.png" alt="Inventory Icon" class="inventory-button-image">
                    </button>`
                : ""}
                </div>
            `;
        }

        return "";
    }

    /**
     * Render the content element
     *
     * @returns String with raw HTML for the content element
     */
    private renderContent(): string {
        return `
            <div class="content">
                ${this._currentGameState?.text.map(text => `<p>${text}</p>`).join("") || ""}
            </div>
        `;
    }

    /**
 * Render de info-box in de rechterbovenhoek
 *
 * @returns String met HTML voor de info-box
 */
    private renderInfoBox(): string {
        const talkedAboutQuest = this._currentGameState?.TalkedAboutQuest;
        const talkedToThors = this._currentGameState?.talkedToThors;
        const checkedUnderBed = this._currentGameState?.CheckedUnderBed;
        const checkedTheCloset = this._currentGameState?.CheckedTheCloset;
        const EnterGuildBase = this._currentGameState?.EnteredGuildBase;
        const TalkedToOrrin = this._currentGameState?.TalkedToOrrin;
        const ExitedTheHouse = this._currentGameState?.ExitedTheHouse;

        // Maak een array van objecten met de doelen en hun condities
        const objectives = [
            { condition: !talkedAboutQuest, text: "- Talk to your son" },
            { condition: talkedToThors, text: "- Exit the house" },
            { condition: ExitedTheHouse, text: "- Find The GuildMaster" },
            { condition: EnterGuildBase, text: "- Talk To the Guildmaster" },
            { condition: !(checkedUnderBed || checkedTheCloset), text: "- Loot the house" },
            { condition: TalkedToOrrin, text: "- Explore the Dungeon" },
            // Voeg andere doelen toe als je wilt
        ];

        // Filter de doelen op basis van de conditie en voeg ze toe aan de HTML
        const infoSlots = objectives
            .filter(obj => obj.condition) // Alleen doelen waar de conditie waar is
            .map(obj => `<div class="info-slot">${obj.text}</div>`); // Zet ze om naar HTML divs

        return `
            <div class="info-box">
                <div class="info-box-title">Objectives</div>
                <div class="info-box-line"><hr></div>
                ${infoSlots.join("")}  <!-- Voeg de info-slot divs toe -->
            </div>
        `;
    }

    /**
     * Render the footer element
     *
     * @returns HTML element of the footer
     */
    private renderFooter(): HTMLElement {
        return html`
            <div class="footer">
                <div class="buttons">
                    <div class="testbox">
                        ${this._currentGameState?.actions.map(button => this.renderActionButton(button))}
                    </div>
                    <div>
                    <div class="objectFlex">
                        ${this._selectedActionButton
                            ? this._currentGameState?.objects.map(button => this.renderGameObjectButton(button)) || ""
                            : ""
                        }
                            </div>
                    </div>
                </div>
            </div>
        `;
    }

    /**
     * Render an action button for a given action reference
     *
     * @returns HTML element of the action button
     */
    private renderActionButton(button: ActionReference): HTMLElement {
        const element: HTMLElement = html`
            <a class="button ${this._selectedActionButton === button ? "active" : ""}">
                ${button.name}
            </a>
        `;

        element.addEventListener("click", () => this.handleClickAction(button));

        return element;
    }

    /**
     * Render a game object button for a given game object reference
     *
     * @returns HTML element of the game object button
     */
    private renderGameObjectButton(button: GameObjectReference): HTMLElement {
        const element: HTMLElement = html`
            <a class="button ${this._selectedGameObjectButtons.has(button) ? "active" : ""}">
                ${button.name}
            </a>
        `;

        element.addEventListener("click", () => this.handleClickGameObject(button));

        return element;
    }

    /**
     * Handle the click on an action button
     *
     * @param button Action button that was clicked
     */
    private async handleClickAction(button: ActionReference): Promise<void> {
        // If this actions needs a game object, show the available game objects.
        if (button.needsObject) {
            this._selectedActionButton = button;
            this._selectedGameObjectButtons.clear();

            this.render();

            return;
        }

        // Otherwise, execute the action and update the game state.
        const state: GameState | undefined = await this._gameRouteService.executeAction(button.alias);

        if (state === undefined) {
            return;
        }

        this.updateGameState(state);
    }

    /**
     * Handle the click on a game object button
     *
     * @param button Game object button that was clicked
     */
    private async handleClickGameObject(button: GameObjectReference): Promise<void> {
        // If no action button was clicked, do not try to handle this click.
        if (!this._selectedActionButton) {
            return;
        }

        // Add the game object to list of selected game objects
        this._selectedGameObjectButtons.add(button);

        // Try to execute the action with all game objects on the list
        const state: GameState | undefined = await this._gameRouteService.executeAction(
            this._selectedActionButton.alias,
            [...this._selectedGameObjectButtons].map(e => e.alias)
        );

        // If 2 more game objects where on the list, clear it.
        if (this._selectedGameObjectButtons.size >= 2) {
            this._selectedActionButton = undefined;
            this._selectedGameObjectButtons.clear();
        }

        // Refresh the web component
        this.render();

        // If no state was returned, exit silently. This can happen when an action needs more than 1 game object.
        if (state === undefined) {
            return;
        }

        // Otherwise, update the game state.
        this.updateGameState(state);
    }
}
